import { FRAME_EVENT_PREFIX, FRAME_TITLE_PREFIX } from "../consts/Frame";

export function getTargetIframe(name: string): HTMLIFrameElement {
    const frameTitle = `webapp.${name}`;
    // based on type of build we are using, the targeted iframe is going to be on of these 2 types
    const queries = [
        `iframe[title="${frameTitle}"]`,
        `iframe[data-title="${frameTitle}"]`,
    ];
    return document.querySelector(queries.join(","));
}

export function getSourceIframeName(source: Window): string {
    const allIframes = [...document.querySelectorAll("iframe")];
    const sourceIframe = allIframes.find(
        (iframe) => iframe.contentWindow === source,
    );
    const title =
        sourceIframe?.getAttribute("data-title") ||
        sourceIframe?.getAttribute("title") ||
        "";
    return title.replace(FRAME_TITLE_PREFIX, "");
}

export function isValidEvent(event) {
    return !!event.data?.eventKey?.includes(FRAME_EVENT_PREFIX);
}

export function getEventParameters(event) {
    const { eventKey, data, requestId } = event.data;

    return {
        type: eventKey.replace(FRAME_EVENT_PREFIX, ""),
        data,
        requestId,
        source: event.source,
    };
}

export function generatePayloadMessage({ type, data, requestId }) {
    return {
        eventKey: `${FRAME_EVENT_PREFIX}${type}`,
        data,
        requestId,
    };
}

export function buildPayload({ type, data, requestId }) {
    return {
        type,
        data,
        requestId,
    };
}
